import { Nilable } from "../shared/utils/Nullable";

export interface ICiudadDTO {
    id: number;
    name: string;
}

export class CiudadDTO {
    public id = 0;
    public nombre = "";

    constructor(json: Nilable<Partial<ICiudadDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICiudadDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
    }

    public toJSON(): ICiudadDTO {
        return {
            id: this.id,
            name: this.nombre
        };
    }
}
